import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import type { PricingTableCurrencySettings } from '../../types';
import { PricingTableHelper } from '../pricing-table.helper';

export const getModifierPreview = (
  flatFee: boolean,
  modifier: string,
  modifierSubtracting: boolean,
  displayCalculatedValue: boolean,
  totalPrice: number,
  currencySettings: PricingTableCurrencySettings
): string => {
  if (flatFee) {
    return `${modifierSubtracting ? '-' : ''}${PricingTableHelper.currencyFormat(
      modifier,
      currencySettings
    )}`;
  } else {
    if (!displayCalculatedValue) {
      return `${modifier}%`;
    }
    const modifierInCurrency = String((Number(totalPrice) * Number(modifier)) / 100);
    return `${modifierSubtracting ? '-' : ''}${PricingTableHelper.currencyFormat(
      modifierInCurrency,
      currencySettings
    )} (${modifier}%)`;
  }
};

export const getModifierLabelWithSuffix = (flatFee: boolean, modifierLabel: string): string =>
  flatFee ? `${modifierLabel} (${t('flat-fee-value')})` : `${modifierLabel} (%)`;
